import { defineComponent, provide, reactive, ref, toRefs } from "vue";
import props from "./props";
import { FormInjectionKey, FormItemContext } from "./const";
export default defineComponent({
  name: "CForm",
  props: { ...props },
  setup(props, { emit, slots, expose }) {
    const { model, labelWidth, rules, readonly } = toRefs(props);
    const children = ref<FormItemContext[]>([]);
    provide(
      FormInjectionKey,
      reactive({
        labelWidth,
        children,
        rules,
        model,
        readonly,
      })
    );
    const formClass = ref("c-form");

    const onSubmit = (e?: Event) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      let error = "";
      for (let i = 0, l = children.value.length; i < l; i++) {
        const item = children.value[i];
        const tip = item.validate();
        if (!error) {
          error = tip;
        }
      }
      emit("sub", error);
      return error;
    };
    const validateField = (prop: string) => {
      let flag = true;
      const field = children.value.find((c) => c.prop === prop);
      if (field) {
        flag = !field.validate();
      }
      return flag;
    };
    expose({ onSubmit, validateField });
    return () => (
      <form class={formClass.value} onSubmit={(e: Event) => onSubmit(e)}>
        {slots?.default ? slots.default() : null}
      </form>
    );
  },
});
